import bookingES from './booking/es'
const es = {
  common: {
    all: 'Todos',
    download: 'Descargar',
    private: 'Privado',
    sigin: 'ACCEDER',
    recoverPassword: 'Recuperar contraseña',
    sendMail: 'Enviar email',
    username: 'Usuario',
    password: 'Contraseña',
    search: 'Buscar',
    continue: 'Continuar',
    ok: 'Aceptar',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    close: 'Cerrar',
    skip: 'Saltar',
    create: 'Crear',
    edit: 'Editar',
    clone: 'Copiar',
    move: 'Mover',
    restore: 'Restaurar',
    addMenu: 'Crear un nuevo menú',
    addContent: 'Añadir al menú',
    addToSubmenu: 'Añadir al submenú',
    addSubmenu: 'Crear submenú',
    addItem: 'Añadir elemento',
    language: 'idioma',
    struct: 'Estructura',
    selectImage: 'Añadir imagen',
    height: 'Altura',
    url: 'URL',
    text: 'Texto',
    back: 'Volver',
    send: 'Enviar',
    of: 'De',
    showMore: 'mostrar más',
    show: 'Mostrar',
    add: 'Añadir',
    refresh: 'Refrescar',

    noData: 'No hay datos',

    open: 'Abrir',
    openNewTab: 'Abrir en nueva pestaña',
    btnText: 'Texto botón',

    collapse: 'Contraer',
    expand: 'Expandir',

    today: 'Hoy',
    tomorrow: 'Mañana',
    m0: 'Enero',
    m1: 'Febrero',
    m2: 'Marzo',
    m3: 'Abril',
    m4: 'Mayo',
    m5: 'Junio',
    m6: 'Julio',
    m7: 'Agosto',
    m8: 'Septiembre',
    m9: 'Octubre',
    m10: 'Noviembre',
    m11: 'Diciembre',
    s0: 'Lunes',
    s1: 'Martes',
    s2: 'Miércoles',
    s3: 'Jueves',
    s4: 'Viernes',
    s5: 'Sábado',
    s6: 'Domingo',
    s0Small: 'Lu',
    s1Small: 'Ma',
    s2Small: 'Mi',
    s3Small: 'Ju',
    s4Small: 'Vi',
    s5Small: 'Sá',
    s6Small: 'Do',

    addToCalendar: 'Añadir al calendario',

    error2mb: 'La imágen no puede superar los 2MB',

    selectMenu: 'Seleccione el menú al que mover el contenido',

    addressToSearch: 'Dirección a buscar',

    totemMenuImportant: 'TOTEM - Menú destacado',
    totemMenuImportantImage: 'TOTEM - Fondo menú',

    infoEditedTranslate: 'Pendiente de traducir',

    dayOfWeekSmall: {
      0: 'Do',
      1: 'Lu',
      2: 'Ma',
      3: 'Mi',
      4: 'Ju',
      5: 'Vi',
      6: 'Sá'
    },
    dayOfWeek: {
      0: 'Domingo',
      1: 'Lunes',
      2: 'Martes',
      3: 'Miércoles',
      4: 'Jueves',
      5: 'Viernes',
      6: 'Sábado'
    },
    required: 'Los campos son requeridos',
    pleaseStandBy: 'Por favor espere',

    clear: 'Limpiar',
    menu: 'Menú',
    content: 'Contenido',
    messages: {
      confirmDelete: '¿Está seguro de que desea eliminarlo?', // Are you sure you want to delete this item?
      noData: 'No hay datos a mostrar',
      pleaseStandBy: 'Por favor espere'
    }
  },
  login: {
    title: 'Formulario de acceso',
    login: 'acceder',
    messages: {
      required: 'El usuario y la contraseña son requeridos',
      userNotFound: 'El usuario o la contraseña no son correctos'
    }
  },
  dashboard: {
    title: 'Dashboard',
    changePassword: 'Cambiar contraseña',
    logout: 'Salir',
    webs: 'Web App',
    welcome: 'Bienvenid@',
    lastModification: 'Última modificación',
    cloneEnterprise: 'Duplicar',
    content: 'Contenido contratado',
    logs: {
      title: 'Actividad reciente',
      username: 'Usuario',
      action: 'Acción',
      menuname: 'Menú',
      lmd: 'Fecha',
      actions: {
        deleted: 'Eliminar',
        update: 'Actualizar',
        sort: 'Ordenar'
      }
    },
    stats: {
      access: 'Accesos Web App ',
      accessMenu: 'Accesos menú ',
      month: 'Mes',
      day: 'Día',
      menu: 'Menú',
      clicks: 'Clicks'
    }
  },
  changePassword: {
    oldPassword: 'Contraseña anterior',
    password: 'Nueva contraseña',
    repeatPassword: 'Repetir contraseña',
    messages: {
      oldPasswordRequired: 'La contraseña anterior es requerida',
      passwordRequired: 'La contraseña es requerida',
      sameAsPassword: 'Las contraseñas deben coincidir',
      UserNotFound: 'El usuario o la contraseña no coinciden',
      success: 'Contraseña actualizada correctamente'
    }
  },
  commonMenus: {
    title: 'Menús comunes',
    alias: 'Alias',
    messages: {
      update: 'Actualizado correctamente',
    },
    assign: 'Asignar'
  },
  users: {
    title: 'Usuarios',
    userTitle: 'Usuario',
    name: 'Usuario',
    email: 'Email',
    client: 'Cliente',
    password: 'Contraseña',
    repeatPassword: 'Repetir contraseña',
    isSuperUser: '¿Es super usuario?',
    enterprises: 'Web Apps',
    defaultEnterprise: 'Cliente por defecto',
    permissions: {
      title: 'Permisos',
      logs: 'Logs',
      stats: 'Estadísticas',
      moveContent: 'Mover contenido',
      cloneMenu: 'Duplicar menú',
      cloneEnterprise: 'Duplicar Web App',
      editDesktopMode: 'Editar modo escritorio',
      commonMenus: 'Editar menús comunes',
      productService: 'Producto/Servicio',
      poll: 'Encuesta',
      dishOrders: 'Pedidos',
      welcomeForm: 'Formulario de entrada',
    },
    dishesMenu: 'Menú administración de platos',
    showDishesMenu: 'Mostrar menú administración de platos',
    showRCovidMenu: 'Mostrar menú formulario Covid',
    showRFormCio: 'Mostrar menú formulario CIO',
    showCustomColorMenu: 'Mostrar config. colores menus',
    hideCustomization: 'Ocultar personalización',
    hideSettings: 'Ocultar configuración',
    hideLogoAndCarousel: 'Ocultar F. logo y carousel',
    hideColors: 'Ocultar F. colores',
    hideWelcomeModal: 'Ocultar F.MSJ bienvenida',
    messages: {
      nameMostCharacters: 'El nombre no puede superar los 50  caracteres',
      nameRequired: 'El email es requerido',
      emailValid: 'El email debe ser válido',
      emailRequired: 'El email es requerido',
      passwordMatch: 'La contraseña no coincide',
    }
  },
  enterprises: {
    title: 'Web Apps',
    enterpriseTitle: 'Cliente',
    name: 'Cliente',
    domain: 'Dominio',
    customURL: 'Custom URL (https://demo.demo.es)',
    allergensIconType: 'Tipo de icono alérgenos',
    privateBGColor: 'Color de fondo del gestor',
    btnBackgroundColor: 'Content btn bgcolor',
    btnTextColor: 'Content btn textcolor',
    foodDrinkTextColor: 'Color título Comida/bebida/producto',
    foodDrinkBGColor: 'Color fondo Comida/bebida/producto',
    permissions: 'Permisos',
    dviewLink: 'Actividades (enlace Dview)',
    dviewLinkShows: 'Cartelera (enlace Dview)',
    dviewLinkAgenda: 'Agenda (enlace Dview)',
    dviewLinkParrilla: 'Parrilla (enlace Dview)',
    dviewLinkCommercial: 'Agentes (enlace Dview)',
    dviewLinkProperty: 'Propiedades (enlace Dview)',
    dviewLinkChannelList: 'Lista de canales (enlace Dview)',
    showMoscaDFeel: 'Mostrar mosca DFeel',
    allergenFilters: 'Mostrar filtro de alérgenos',
    showDishesImage: 'Mostrar imagen',
    showDishesAllergens: 'Mostrar alérgenos',
    foodIconRight: 'Mostrar icono a la derecha',
    expandFirstElement: 'Abrir el primer menú automáticamente',
    expandFirstElementWithoutMainMenu : 'Abrir menú general automáticamente sin abrir el primer menú',
    meteo: 'Meteo (lugar)',
    linkCommon: 'Enlazar menús compartidos',
    clearStats: 'Resetear estadísticas',
    messages: {
      nameMostCharacters: 'El nombre no puede superar los 50  caracteres',
      nameRequired: 'El email es requerido',
      domainMostCharacters: 'El dominio no puede superar los 50  caracteres',
      domainRequired: 'El dominio es requerido',
    },
    backDomain: 'Btn volver (dominio)',
    authType: 'Tipo auth.',
    editMenus: 'Configuración'
  },
  settings: {
    title: 'Personalización',
    welcomeModal: {
      title: 'Mensaje de bienvenida',
      isWelcomeModal: 'Utilizar mensaje de bienvenida',
      preview: 'Vista previa',
      name: 'Nombre',
      image: 'Imagen',
      icon: 'Icono',
      message: 'Mensaje',
      colors: 'Colores',
      countDown: 'Cuenta atrás',
      date: 'Fecha',
      withButton: 'Con botón',
      text: 'Texto',
      link: 'Enlace',
      hide: 'Ocultar',
      remember: 'Solo mostrar una vez'
    },
    logoAndCarousel: {
      title: 'Logo - Carrusel - Idiomas',
      languages: 'Idiomas',
      logo: 'Logo',
      carousel: 'Carrusel',
      defaultLocale: 'Idioma def.',
      messages: {
        update: 'Actualizado correctamente',
      }
    },
    colors: {
      title: 'Apariencia',
      primary: 'Principal',
      secundary: 'Secundario',
      content: 'Contenido',
      backgroundColor: 'Color de fondo',
      fontColor: 'Color de texto',
      fontSize: 'Tamaño fuente',
      font: 'Fuente',
      shadowMenu: 'Sombra menu',
      shadowSubmenu: 'Sombra submenu',
      line: 'Línea',
      messages: {
        update: 'Actualizado correctamente',
      },
      textFormat: 'Formato'
    },
    formTerms: {
      title: 'Términos y condiciones',
      showCookiePolicy: 'Mostrar políticas de cookies',
      showPrivacyPolicy: 'Mostrar políticas de privacidad',
      cookiePolicy: 'Política de cookies',
      privacyPolicy: 'Política de privacidad',
      info: 'Este sitio utiliza cookies. Al continuar navegando por el sitio, usted acepta nuestro uso de cookies.',
      agree: 'Aceptar',
      learnMore: 'Saber más',
    },
    info: {
      recommendations: 'Recomendaciones',
      logo: {
        title: 'Logo',
        description: 'Tamaño y resolución mínima de la imagen recomendado 800x338px - 72ppp. Formato png con fondo transparente.'
      },
      carousel: {
        title: 'Carrusel',
        description: 'Tamaño y resolución mínima de la imagen recomadado 1280x720px - 72ppp. Formato jpeg. Máximo tres imágenes'
      },
      language: {
        title: 'Idiomas',
        description: 'Establezca los idiomas de la aplicación. Por defecto se encuentra en español. Recuerde que si selecciona varios idiomas deberá colocar su traducción. La aplicación no traduce automáticamente.'
      }
    }
  },
  menus: {
    name: 'Menús',
    title: 'Configuración',
    menuName: 'Nombre del menú',
    submenuName: 'Nombre del submenú',
    submenus: 'Submenús',
    isMenuTemp: 'Menú temporal',
    isSubmenuTemp: 'Submenú temporal',
    WAAsContent: 'WebApp como contenido',
    domain: 'WebAPP',
    editors: 'Editores',
    info: {
      noExistSubmenu: 'No existen submenús creados',
      addMenu: 'Pueden empezar a añadir menus pulsando en siguiente botón',
      saveBeforeEdit: 'Guardar antes de editar los elementos nuevos',
      collapse: 'Para ordenar debe contraer el contenido',
      iconAndFunction: 'Iconografía y funciones generales:',
      addContent: 'Añadir contenido',
      moveContent: 'Mover contenido',
      sortContent: 'Ordenar contenido',
      editContent: 'Editar contenido',
      language: 'Añadir traducciones',
      deleteContent: 'Eliminar contenido',
      cancel: 'Cancelar contenido',
      menuWithoutContent: 'Menú o submenú sin contenido',
      menuWithContent: 'Menú o submenú con contenido',
      saveContent: 'Guardar contenido',
      submenus: 'Menú con submenús',
      lockContent: 'Contenido externo no editable',
      finished: 'Menú temporal fuera de fecha',
      cloneContent: 'Duplicar contenido',
      hideContent: 'Ocultar contenido'
    },
    availability: {
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin',
      noEndDate: 'Sin fecha fin'
    },
    messages: {
      update: 'Actualizado correctamente',
      delete: 'Eliminado correctamente'
    }
  },
  desktopMode: {
    title: 'Vista escritorio'
  },
  share: {
    title: 'Compartir',
    downloadSVG: 'Descargar en formato SVG',
    downloadPNG: 'Descargar en formato PNG',
    isPrivate: 'Privado',
    addAccess: 'Crear acceso',
    alias: 'Alias'
  },
  confirmDelete: {
    title: '¿Desea eliminar este contenido?',
    message: 'Esta accion no se puede deshacer'
  },
  confirmUndo: {
    title: '¿Desea continuar?',
    message: 'Perderá los cambios no guardados'
  },
  gallery: {
    maxInfo: 'Importante: Máximo 12 imágenes por galería'
  },
  map: {
    lat: 'Latitud',
    lon:'Longitud'
  },
  twitter: {
    account: 'Cuenta'
  },
  facebook: {
    account: 'Cuenta'
  },
  instagram: {
    instagramIframe: 'Iframe'
  },
  activity: {
    type: 'Tipo',
    show: 'Mostrar',
    messages: {
      noActivities: 'No hay actividades para el día seleccionado'
    },
    book: 'Reservar'
  },
  timeline: {
    addEvent: 'Crear evento',
    title: 'Título',
    description: 'Descripción',
    hideHeader: 'Ocultar cabecera',
    textHeader: 'Título cabecera',
    subtextHeader: 'Subtítulo cabecera',
    isTextHeader: 'Cabecera con título'
  },
  contact: {
    addItem: 'Crear elemento',
    description: 'Valor',
    hideDivider: 'Ocultar divisor',
    url: 'URL'
  },
  divider: {
    space: 'Espacio'
  },
  site: {
    title: 'Título',
    subtitle: 'Subtítulo',
    address: 'Dirección',
    phone: 'Teléfono',
    web: 'Web',
    email: 'E-mail',
    moreInfo: 'Más información',
    lat: 'Latitud',
    lon: 'Longitud',
    showMoreInfo: 'Mostrar más información',
    hideMoreInfo: 'Ocultar información',
    siteLink: 'Link',
    siteLinkURL: 'URL',
    siteLinkName: 'Nombre',
    siteLinkDialog: 'Popup',
  },
  agenda: {
    showMoreInfo: '+ info',
  },
  wifi: {
    name: 'Nombre',
    ssid: 'SSID',
    password: 'Contraseña',
    Authentication: 'Autenticación',
    wep: 'WEP',
    wpa: 'WPA'
  },
  food: {
    name: 'Nombre',
    ingredients: 'Ingredientes',
    price: 'Precio',
    note: 'Nota',
    vegan: 'Vegano',
    vegetarian: 'Vegetariano',
    new: 'Nuevo',
    spicy: 'Picante',
    recommended: 'Recomendado',
    allergens: 'Alérgenos',
    containsAllergens: 'Contiene alérgenos'
  },
  product: {
    name: 'Nombre',
    description: 'Descripción',
    price: 'Precio',
    promotion: 'Promoción',
  },
  linkDomain: {
    name: 'Nombre',
    domain: 'Subdominio',
    newTab: 'Abrir en nueva pestaña'
  },
  form: {
    formDestinationMail: 'Correo de destino',
    formRoomNumber: 'Nº Habitación',
    formDateTime: 'Fecha y hora',
    formNumberOfPeople: 'Nº de personas',
    name: 'Nombre',
    formTextBtn: 'Texto del botón',
    roomNum: 'Nº Habitación',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    date: 'Fecha',
    time: 'Hora',
    numOfItems: 'Número de items',
    numOfPeople: 'Número de personas',
    lblNumOfItems: 'Texto campo número de items',
    formLimitNumberOfItem: 'Límite número de items',
    observations: 'Observaciones',
    messageSend: 'Solicitud enviada'
  },
  dishes: {
    title: 'Platos',
    menu: 'Menú',
    food: 'Plato',
    ingredients: 'Ingredientes',
    price: 'Precio',
    vegan: 'Vegano',
    vegetarian: 'Vegetariano',
    allergens: 'Alérgenos',
    selectYourAllergy: 'Seleccione los alérgenos',
    allergenFilter: 'FILTRO DE ALÉRGENOS',
    selectAllergens: 'Seleccione los alérgenos para ocultar los productos que los contienen',
    containsAllergens: 'Contiene alérgenos'
  },
  products: {
    title: 'Producto/Servicio',
  },
  menuType: {
    selectMenuType: 'Seleccione el tipo de contenido a añadir',
    demo: 'Demo',
    activities: 'Actividades',
    submenu: 'Submenú',
    simpleText: 'Texto simple',
    space: 'Separador',
    image: 'Imagen',
    iframe: 'Iframe',
    alert: 'Alerta',
    gallery: 'Galería',
    video: 'Vídeo',
    meteo: 'Meteo',
    map: 'Mapa',
    twitter: 'Twitter',
    facebook: 'Facebook',
    pdf: 'PDF',
    timeline: 'Timeline',
    text: 'Texto',
    contact: 'Contacto',
    divider: 'Línea',
    shows: 'Cartelera',
    site: 'Sitio',
    agenda: 'Agenda',
    parrilla: 'Parrilla',
    wifi: 'Wifi',
    property: 'Propiedades',
    commercial: 'Agentes',
    queue: 'Turnos',
    food: 'Comida/Bebida',
    linkDomain: 'Enlace webapp',
    form: 'Formulario',
    productService: 'Producto/Servicio',
    pdfTranslate: 'PDF T.',
    linkExternal: 'Enlace externo',
    channelList: 'Lista canales',
    WAAsContent: 'WebApp como contenido',
    acttiv: 'Acttiv',
    poll: 'Encuestas',
    instagram: 'Instagram',
    iconList: 'Lista de iconos',
    dropdownButton: 'Botón desplegable',
    dfiles: 'dfiles',
    rcovid: 'R-Covid',
    imageTranslate: 'Image T.',
    iberostarFood: 'Iberostar',
    icons: 'Iconos',
    hsconsulting: 'Hsconsulting',
    brochure: 'Folleto',
    infoTen: 'InfoTen',
    cmActivities: 'Actividades (ContentManager)',
    cMBooking: 'Reservas (ContentManager)',
    menuExtFood: 'Menu ext. Comida',
    attendance: 'Registro entrada/salida',
    cMAttendance: 'Registro entrada/salida',
    cmWeeklyMenu: 'Menú semanal',
    formCio: 'Form CIO',
    dviewcontentMessages: 'Mensajes y avisos (dviewcontent)',
    servatur: 'Servatur',
    interactiveMaps: 'Mapa interactivo',
    abamaRequestReservation: 'ABAMA solicitud de reserva',
    effilabel: 'Effilabel',
    effiwaste: 'Effiwaste',
    chekin: 'Chekin',
    qAndA: 'Q&A',
    abamaLinkRoom: 'Link room',
    abamaRequest: 'Request room',
  },
  totem: {
    weatherForecast: 'Pronóstico del tiempo',
    languageSelector: 'Selector de idioma',
    accessibility: 'Accessibilidad',
    mobileVersion: 'Versión móvil'
  },
  schedule: {
    startTime: 'Hora inicio',
    interval: 'Intervalo'
  },
  availability: {
    isTemp: 'Temporal',
    periodicity: 'Periodicidad',
    allDays: 'Todos los días',
    oneDay: 'Un día',
    recurrence: 'Recurrente',
    isAllTimes: 'Todo el día',
    date: 'Fecha del evento',
    dateStart: 'Fecha de inicio',
    dateEnd: 'Fecha de fin',
    timeStart: 'Hora de inicio',
    timeEnd: 'Hora de fin',
    noEndDay: 'Sin fecha fin',
    byWeek: 'Por semana',
    byMonth: 'Por mes',
    alternation: 'Alternancia'
  },
  customAuth: {
    guestAccess: 'Acceso huesped',
    bookingCode: 'Reserva',
    entranceDate: 'Fecha entrada',
    room: 'Nº Habitación',
    surname: 'Apellidos',
    noray: {
      noCheckin: 'Debe hacer el Check-in',
      exit: 'Salida realizada',
      noBookin: 'La reserva no existe',
      error: 'Error desconocido'
    },
    logoutMsg: '¿Está seguro que quiere salir?'
  },
  acttiv: {
    primaryColor: 'Color primario',
    secundaryColor: 'Color secundario',
    titleColor: 'Color del título',
    descriptionColor: 'Color descripción',
    info: 'Actividades sujetas a cambios',
    reservationCreated: 'Reserva creada',
    locator: 'Localizador',
    disclaimer: 'Programa de animación sujeto a posibles cambios',
    form: {
      participant: 'Participante',
      title: 'Datos para la reserva',
      numPeople: 'Nº participantes',
      name: 'Nombre',
      tutorName: 'Nombre tutor',
      participantName: 'Nombre participante',
      lastName: 'Apellidos',
      email: 'Email',
      dni: 'DNI / NIE',
      phone: 'Teléfono',
      room: 'Habitación',
      note: 'Nota',
      age: 'Edad',
      allergy: 'Alergia',
      youngerExit: '¿El menor puede entrar y salir solo del club?',
      youngerEmergency: '¿Se autoriza asear al menor en caso de emergencia?',
      cancelReservation: 'Cancelar reserva',
      error: {
        tutorNameNotValid: 'Nombre del tutor no válido',
        participantNameNotValid: 'Nombre de los participantes no válidos',
        habitacionNotValid: 'Número de habitación no válido',
        emailNotValid: 'Email no válido'
      },
    }
  },
  poll: {
    alias: 'Alias',
    selectType: 'Seleccione el tipo',
    question: 'Pregunta',
    answer: 'Respuesta',
    multiSelection: 'Multi-selection',
    singleSelection: 'Single selection',
    addAnswer: 'Añadir respuesta',
    rating: 'Valorar',
    number: 'Número',
    messages: {
      sendDataSuccess: 'Respuestas enviadas correctamente'
    }
  },
  reservationList: {
    reservations: 'Reservas',
    myReservations: 'Mis reservas',
    status: 'Estado',
    participant: 'Participante',
    date: 'Fecha',
    OK: 'Correcto',
    CANCEL: 'CANCELADA'
  },
  iconList: {
    title: 'Título',
    description: 'Descripción'
  },
  dropdownButton: {
    colors: 'Colores'
  },
  rcovid: {
    title: 'Formulario',
    name: 'Nombre',
    lastName: 'Apellidos',
    email: 'Email',
    company: 'Empresa',
    terms: 'Aceptar términos',
    ni: 'DNI',
    phone: 'Teléfono',
    messageSend: 'Confirmado',
    LMD: 'Fecha'
  },
  iberostarFood: {
    restaurant: 'Restaurante',
    primaryColor: 'Color principal',
    secondaryColor: 'Color secundario',
  },
  hsconsulting: {
    hotel: 'Hotel',
    installation: 'Instalación',
  },
  brochure: {
    description: 'Descripción',
    note: 'Nota',
    facts: 'Datos de interés',
    hours: 'Horarios',
    price: 'Precio',
    services: 'Servicios',
    contact: 'Contacto',
    phone: 'Teléfono',
    fax: 'Fax',
    email: 'Email',
    web: 'Web',
    location: 'Ubicación',
    zone: 'Zona',
    municipaly: 'Municipio',
    address: 'Dirección',
    postalCode: 'Código postal',
    lat: 'Latitud',
    lon: 'Logitud',
    pdf: 'PDF',
    openNewTab: 'Abrir en nueva pestaña',
    download: 'Descargar',
    info: 'Información',
  },

  dtouch: {
    email: 'Email',
    room: 'Habitación',
    access: 'Acceder',
    reservations: 'Reservas',
    pax: 'Asistentes',
    showBookings: 'Mostrar reservas',
    editBooking: 'Modificar reserva',
    cancelBooking: 'Cancelar reserva',
    outdatedBooking: 'Finalizado',
    request: {
      name: 'Nombre',
      description: 'Descripción',
      request: 'Pedir',
      report: 'Reportar',
      title: 'Solicitudes',
      item: 'Item',
      fullName: 'Nombre completo',
      email: 'Email',
      room: 'Habitación',
      comment: 'Comentarios',
      status: 'Estado',
      captureImage: 'Capturar foto (opcional)',
      messages: {
        ok: 'Solicitud registrada correctamente',
        okUpdate: 'Solicitud actualizada correctamente',
        fieldsRequired: 'Faltan campos por informar (*)',
      },
    },
    workspace: {
      weeklyMenu: {
        contentID: 'ID contenido',
      },
    },
    welcomeForm: {
      title: 'Registro entrada',
      name: 'Nombre',
      phone: 'Teléfono',
      email: 'Email',
      refresh: 'Refrescar',
    },
    activity: {
      all: 'Todos',
      messages: {
        noActivities: 'No hay actividades para el día seleccionado',
        disclaimer: 'Programa de animación sujeto a posibles cambios',
      },
    },
    /*
    activity: {
      messages: {
        noActivities: 'No hay actividades para el día seleccionado',
        disclaimer: 'Programa de animación sujeto a posibles cambios',
      },
    },
    */
    food: {
      name: 'Nombre',
      ingredients: 'Ingredientes',
      price: 'Precio',
      vegan: 'Vegano',
      vegetarian: 'Vegetariano',
      new: 'Nuevo',
      recommended: 'Recomendado',
      note: 'Nota',
      allergens: 'Alérgenos',
      image: 'Imagen',
      containsAllergens: 'Contiene alérgeno',
    },
    menuExtFood: {
      externalID: 'ID externo',
      isAll: 'Todos',
    },
    dishOrders: {
      title: 'Pedidos',
      allowOrders: 'Permitir pedidos',
      order: 'Pedir',
      status: 'Estado',
      cd: 'Fecha creación',
      closed: 'Cerrado',
      closedOpen: 'Cerrado/Abierto',
      open: 'Abierto',
      close: 'Cerrar',
      numItems: 'N. items',
      name: 'Nombre',
      price: 'Precio',
      total: 'Total',
      cancelOrder: 'Cancelar',
      confirmOrder: 'Confirmar',
      payOrder: 'Pagar',
      image: 'Imagen',
      clearOrder: 'Vaciar',
      all: 'Todos',
      note: 'Nota',
      finalize: 'Finalizar',
      noData: 'El carrito está vacío',
      labelExtra: 'Texto a mostrar',
      onlyOne: 'Permitir seleccionar solo uno',
      FixCart: 'Fijar carrito',
      percentage: 'Porcentaje',
      allInclusive: 'Todo incluido',
      includeExtras: 'Incluir extras',
      extras: {
        title: 'Extras',
        name: 'Nombre',
        price: 'Precio',
      },
      formConfirm: {
        title: 'Último paso',
        fullName: 'Nombre completo',
        room: 'Habitación',
        name: 'Nombre',
        lastName: 'Apellido',
        email: 'Email',
        paymentMethods: 'Método de pago',
        observations: 'Observaciones',
        paymentOptions: {
          cash: 'Efectivo',
          creditCard: 'Tarjeta',
          room: 'Cargo habitación',
        },
        required: 'Requerido',
        acceptTerms: {
          title: 'Aceptar termimos y condiciones.',
          accept: 'Aceptar ',
          terms: 'terminos y condiciones.'
        },
        card: {
          title: 'Card info',
          name: 'Nombre completo',
          number: 'Nº tarjeta',
          expiryMonth: 'Mes exp.',
          expiryYear: 'Año exp.',
          cvv: 'CVV'
        },
      },
      points: {
        title: 'Puntos de pedidos',
        point: 'Punto de pedido',
        name: 'Nombre',
        order: 'Pedido',
      },
      statusValues: {
        INI: 'Inicial',
        confirmed: 'Confirmado',
        finished: 'Finalizado',
      },
      messages: {
        orderAdded: 'Pedido añadido',
        rememberConfirmOrder: 'Recuerda confirmar el pedido',

        orderConfirmed: 'Pedido confirmado',
      },
    },
    formCio: {
      form: 'Formulario',
      messageSend: 'Enviado',
    },
  },
  dishOrders: {
    title: 'Pedidos',
  },
  welcomeForm: {
    title: 'Formulario de entrada',
  },
  messages: {
    title: 'Chat',
    typeSomething: 'escribe alguna cosa...',
    sessionNotfound: 'Chat no disponible',
  },
  qAndA: {
    question: 'Pregunta',
    answer: 'Respuesta',
  },
  noray: {
    fields: {
      arrivalDate: 'Fecha llegada',
      checkInDate: 'Fecha check-in',
      email: 'Email',
      hotelVoucher: 'Vale hotel',
      name: 'Nombre',
      no: 'No',
      phoneNo: 'Teléfono',
      roomNo: 'Habitación',
      voucher: 'Vale',
    },
    messages: {
      required: 'Requerido',
    },
  },
  formCio: {
    title: 'Formularios',
  },
  booking: bookingES,
  /*
  booking: {
    allowReservations: 'Permitir reservas',
    reservationRequired: 'Requiere reserva',
    moreInfo: '+ info',
    cancelReservation: 'Cancelar r.',
    reservation: 'Reservar',
    addCalendar: '+ CAL',
    place: 'Lugar',
    meetingPoint: 'Punto de encuentro',
    acttiv: {
      hotel: 'Hotel',
    },
  }*/
}

export default es
